import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  padding-left: 16px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0px 1px 0px ${({ theme }) => theme.colors.grey000};
`;

export const CategoryItemWrapper = styled.div`
  padding: 17px 16px;
  cursor: pointer;

  ${({ selected, theme }) =>
    selected &&
    `
  color: ${theme.colors.blueMain};
  box-shadow: inset 0 -4px 0 ${theme.colors.blueMain};
`}
`;

export const CategoryItem = styled(typography.BodyTextOneRegularTypography)`
  margin: 0;
`;
